import Tween from "tween.ts";
import Animation from "./Animation";
import Element from "../entities/Firework";
import { FIREWORK_INITIAL_Y_OFFSET, FW_ANIM_START_INDEX } from "../types/Config";
import WinningIcon from "../entities/WinningIcon";

export interface WFAnim {
  grid: (Element | WinningIcon)[][],
  onComp: () => void
}

export default class WaterFallAnimation extends Animation {
  grid: (Element | WinningIcon)[][];
  animDuration: number
  maxY: number;
  isOnCompFinished = false;
  onComp: () => void;
  constructor(WF: WFAnim, animDuration: number) {
    super();
    this.grid = WF.grid;
    this.animDuration = animDuration;
    this.onComp = () => {
      this.isOnCompFinished = true;
      WF.onComp()
    };
    this.startAnim();
  }
  startAnim() {
    const wfGrid = this.generateWaterFall();
    wfGrid.forEach((fwArr, eI) => {
      setTimeout(() => {
        fwArr.forEach(firework => {
          const coord = { y: firework.y - FIREWORK_INITIAL_Y_OFFSET };
          new Tween.Tween(firework)
            .to(coord, this.animDuration)
            .easing(Tween.Easing.Linear.None)
            .onComplete(() => eI == FW_ANIM_START_INDEX && !this.isOnCompFinished ? this.onComp() : "")
            .start();
        })
      }, eI * 100);
    })
  }

  generateWaterFall() {
    return [
      [this.grid[0][0]],
      [this.grid[1][0], this.grid[0][1]],
      [this.grid[2][0], this.grid[1][1], this.grid[0][2]],
      [this.grid[3][0], this.grid[2][1], this.grid[1][2], this.grid[0][3]],
      [this.grid[3][1], this.grid[2][2], this.grid[1][3]],
      [this.grid[3][2], this.grid[2][3]],
      [this.grid[3][3]]
    ]
  }
}